import { convertUtcToLocalDate } from 'library/time';

export const THEME_NAMES = {
  user: 'user',
  activity: 'activity',
  competency: 'competency',
  template: 'template',
  userleave: 'userleave',
  roster: 'roster',
  assignment: 'assignment',
  location: 'location',
  route: 'route',
  leg: 'leg',
  itinerary: 'itinerary',
  booking: 'booking',
  rosterbuilder: 'rosterbuilder'
};

export const formatTags = (list = []) => list.map(item => ({
  key: item.tag_id,
  label: item.tag.qualified_name
}));
export const unFormatTags = (list = []) => list.map(item => ({
  tag_id: item.key,
  tag: { qualified_name: item.label }
}));

export const formatItemTag = (item = {}) => ({
  ...item,
  start_date: convertUtcToLocalDate(item.start_date),
  expiry_date: convertUtcToLocalDate(item.expiry_date)
});
export const formatItemTagList = (list = []) => list.map(item => formatItemTag(item));

export const getAddedTags = (tags, original, themeId, objectId) => tags.filter(x => original.filter(y => y.key === x.key).length === 0)
  .map(item => ({
    tag: item.key,
    theme: themeId,
    object_id: objectId,
    start_date: null,
    expiry_date: null
  }));
export const getRemovedTags = (tags, original, source) => original.filter(x => tags.filter(y => y.key === x.key).length === 0)
  .map(item => ({
    id: source.find(x => x.tag_id === item.key).id
  }));
